<div class="video-play-circle">
    <i [title]="attachmentName" class="icon" nz-icon nzType="play-circle" nzTheme="outline"></i>
</div>